import { render } from "./SectionTrois.vue?vue&type=template&id=3f287b0d&ts=true"
import script from "./SectionTrois.vue?vue&type=script&lang=ts"
export * from "./SectionTrois.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__